import React from 'react';
import { Link } from 'react-router-dom';
import { Feather, Heart } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* About */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <Feather className="w-8 h-8 text-amber-400" />
              <span className="text-2xl font-serif font-bold">Laura Novak</span>
            </div>
            <p className="text-slate-400 leading-relaxed mb-6">
              Journalist turned novelist. From The New York Times to Berkeley mysteries 
              and Downtown LA comedy, crafting stories that captivate and intrigue.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-amber-400">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-slate-400 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-slate-400 hover:text-white transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/books" className="text-slate-400 hover:text-white transition-colors">
                  Books
                </Link>
              </li>
              <li>
                <Link to="/news" className="text-slate-400 hover:text-white transition-colors">
                  News
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Books */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-amber-400">Books</h3>
            <ul className="space-y-3">
              <li className="text-slate-400">
                An LA Story (Seeking Publisher)
              </li>
              <li className="text-slate-400">
                Murder at the Mailbox
              </li>
              <li className="text-slate-400">
                Finding Clarity
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-400 text-sm">
              © {currentYear} Laura Novak. All rights reserved.
            </p>
            <p className="text-slate-400 text-sm flex items-center gap-2">
              Made for Storytelling with <Heart className="w-4 h-4 text-red-500 fill-current" /> by <a href="https://www.kd70.com/" target="_blank" rel="noopener noreferrer" className="text-amber-400 hover:text-amber-300 transition-colors">KD70</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;